import type { TimetableDay } from '@noorview/core';
import { pad2 } from '@noorview/core';

/**
 * A safety net for Clear month: the month's times are kept on this device for 30 days after they're cleared, so a
 * mistaken clear can be undone even without the original file. Used by the website and the iPhone app.
 */
export interface KeyValueStore { getItem(k: string): string | null; setItem(k: string, v: string): void; removeItem(k: string): void }

const DAYS_KEPT = 30;
const key = (masjidId: string, y: number, m: number) => `nv.cleared-month.${masjidId}.${y}-${pad2(m)}`;

export function keepClearedMonth(store: KeyValueStore, masjidId: string, y: number, m: number, days: readonly TimetableDay[]) {
  try { store.setItem(key(masjidId, y, m), JSON.stringify({ at: Date.now(), days })); } catch { /* storage full or blocked: Undo still works for now */ }
}

/** The times cleared from this month (within the last 30 days), or null. */
export function clearedMonth(store: KeyValueStore, masjidId: string, y: number, m: number): TimetableDay[] | null {
  try {
    const v = JSON.parse(store.getItem(key(masjidId, y, m)) ?? 'null') as { at: number; days: TimetableDay[] } | null;
    if (!v || !Array.isArray(v.days) || !v.days.length) return null;
    if (Date.now() - v.at > DAYS_KEPT * 86_400_000) { store.removeItem(key(masjidId, y, m)); return null; }
    return v.days;
  } catch { return null; }
}

export function forgetClearedMonth(store: KeyValueStore, masjidId: string, y: number, m: number) {
  try { store.removeItem(key(masjidId, y, m)); } catch { /* nothing to do */ }
}
